import { Link, useNavigate } from 'react-router-dom';
import { VideoCameraIcon, DocumentTextIcon, TableCellsIcon, BookOpenIcon, SparklesIcon } from '@heroicons/react/24/outline';
import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';

function Education() {
    const navigate = useNavigate();
    const { t } = useTranslations();
    
    const sections = [
        {
            id: 'books',
            title: t('education.ebooks'),
            description: t('education.ebooksDescription'),
            icon: DocumentTextIcon,
            path: '/education/books'
        },
        {
            id: 'video',
            title: t('education.videoLessons'),
            description: t('education.videoLessonsDescription'),
            icon: VideoCameraIcon,
            path: '/education/video'
        },
        {
            id: 'glossary',
            title: t('education.glossary'),
            description: t('education.glossaryDescription'),
            icon: BookOpenIcon,
            path: '/education/glossary'
        },
        {
            id: 'other',
            title: t('education.otherMaterials'),
            description: t('education.otherMaterialsDescription'),
            icon: BookOpenIcon,
            path: '/education/other'
        },
        {
            id: 'lectures',
            title: t('education.lectures'),
            description: t('education.lecturesDescription'),
            icon: DocumentTextIcon,
            path: '/education/lectures'
        },
        {
            id: 'indicators',
            title: t('education.indicators'),
            description: t('education.indicatorsDescription'),
            icon: SparklesIcon,
            path: '/education/indicators'
        },
    ];

    return (
        <div className="min-h-screen pb-20">
         
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {sections.map((section) => (
                    <div 
                        key={section.id}
                        className="bg-white rounded-[20px] p-6"
                    >
                        <div className="mb-4">
                            <div className="bg-primary w-12 h-12 rounded-full flex items-center justify-center mb-4">
                                <section.icon className="h-6 w-6 text-[#277B6F]" />
                            </div>
                            <h2 className="text-xl font-bold mb-2">{section.title}</h2>
                            <p className="text-gray-600 text-sm mb-6">
                                {section.description}
                            </p>
                        </div>
                        <Link
                            to={section.path}
                            className="inline-flex text-[14px] md:text-[18px] items-center text-black font-medium bg-primary px-4 py-2 rounded-full hover:bg-primary/90 transition-colors"
                        >
                            {t('education.goToSection')}
                        </Link>
                    </div>
                ))}



                <BottomNav />
            </div>
        </div>
        
    );
}

export default Education; 